import { styled } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { createElement } from 'react';
import '../../utilities/get-styleprop.js';
import '../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../ErrorLabel/ErrorLabel.js';
import '../../FormItem/FormItem.js';
import '../../Input/Input.js';
import '../../InputLabel/InputLabel.js';
import '../../TextInput/TextInput.js';
import '../../InputAddon/InputAddon.js';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import '../../Button/Button.js';
import { colors } from '../colors.js';
import { HEADER_HEIGHT } from './constants.js';
import HeaderButton from './HeaderButton.js';
import SearchField from './SearchField.js';

const HeaderWrapper = styled(Div)`
  height: ${HEADER_HEIGHT}px;
  width: 100%;
  background-color: ${({
  theme
}) => theme.palette.black[100]};
  border-bottom: 1px solid ${({
  theme
}) => theme.palette.black[80]};
  display: flex;
  align-items: center;
`;

const HeaderTitle = styled(Span)`
  flex: 1;
  color: ${colors.menuTitle};
  padding-left: ${({
  theme
}) => theme.spacing.sm}px;
`;

const HeaderComponent = ({
  styles = {},
  children
}) => {
  return /*#__PURE__*/createElement(HeaderWrapper, styles.root, children);
};
const Header = Object.assign(HeaderComponent, {
  Button: HeaderButton,
  Title: HeaderTitle,
  SearchField
});

export default Header;
